import { render, staticRenderFns } from "./WarehouseConfirmDelete.vue?vue&type=template&id=47a2313e&scoped=true&"
import script from "./WarehouseConfirmDelete.vue?vue&type=script&lang=js&"
export * from "./WarehouseConfirmDelete.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "47a2313e",
  null
  
)

export default component.exports